import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import IconButton from "@khanacademy/wonder-blocks-icon-button";
import {Spring} from "@khanacademy/wonder-blocks-layout";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelLarge} from "@khanacademy/wonder-blocks-typography";
import {Guide, toolbarHeight} from "@khan/guide-ui";

import {KhanmigoDefault} from "./khanmigo-default.tsx";

import caretLeftBold from "@phosphor-icons/core/bold/caret-left-bold.svg";
import caretRightBold from "@phosphor-icons/core/bold/caret-right-bold.svg";
import xIcon from "@phosphor-icons/core/regular/x.svg";

type Props = {
    disabled?: boolean;
    showChat: boolean;
    setShowChat: (newValue: boolean) => void;
};

export default function ChatSidebar(props: Props) {
    const {disabled, showChat, setShowChat} = props;

    return (
        <>
            {!showChat && (
                <Clickable
                    style={styles.expander}
                    onClick={() => setShowChat(!showChat)}
                    disabled={disabled}
                >
                    {() => (
                        <>
                            <View style={styles.caretContainer}>
                                <PhosphorIcon
                                    icon={
                                        showChat
                                            ? caretRightBold
                                            : caretLeftBold
                                    }
                                    style={styles.circleButton}
                                />
                            </View>
                            <KhanmigoDefault size={40} />
                        </>
                    )}
                </Clickable>
            )}
            <View
                style={[styles.guideOnTheSide, !showChat && styles.hideGuide]}
            >
                <View style={styles.miniHeader}>
                    <LabelLarge>{t`Khanmigo`}</LabelLarge>
                    <View style={styles.pill}>{t`BETA`}</View>
                    <Spring />
                    <IconButton
                        onClick={() => setShowChat(false)}
                        icon={xIcon}
                        kind="tertiary"
                        actionType="neutral"
                    />
                </View>
                <Guide skipSpeechOnboarding={true} />
            </View>
        </>
    );
}

const styles = StyleSheet.create({
    miniHeader: {
        padding: spacing.medium_16,
        height: toolbarHeight,
        flexDirection: "row",
        paddingLeft: spacing.medium_16,
        borderBottom: `1px solid ${color.offBlack8}`,
        alignItems: "center",
    },
    expander: {
        background: color.offWhite,
        borderLeft: `1px solid ${color.offBlack8}`,
        display: "flex",
        alignItems: "center",
        paddingTop: spacing.medium_16,
        flexDirection: "column",
        boxShadow: "-4px 0px 4px 0px #0000000D",
        // @ts-expect-error - Aphrodite doesn't like this
        ":hover:not([aria-disabled=true])": {
            backgroundColor: color.offBlack8,
        },
    },
    guideOnTheSide: {
        maxWidth: 400,
        backgroundColor: color.white,
        borderLeft: `1px solid ${color.offBlack8}`,
    },
    hideGuide: {
        display: "none",
    },
    caretContainer: {
        width: spacing.large_24,
        height: spacing.large_24,
        marginBottom: spacing.xSmall_8,
        background: color.white,
        border: `1px solid ${color.offBlack8}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: spacing.medium_16,
        boxShadow: "0px 8px 8px 0px #21242C14",
    },
    circleButton: {
        width: spacing.medium_16,
        height: spacing.medium_16,
    },
    pill: {
        background: color.white,
        fontSize: spacing.xSmall_8,
        fontWeight: "normal",
        marginBottom: spacing.xSmall_8,
    },
});
